<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Cartera de Valores</h4>
            <div class="small text-muted">Administración de cheques en cartera</div>
          </b-col>
          
          <b-col sm="5">            
            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>                    
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer" v-if="table.mostrarFiltros">
        <b-row>
          <b-col md="2">
            <b-form-group label="Desde (vto)">            
              <b-form-input type="date" size="sm" v-model="filters.date_start" placeholder="Fecha Desde"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Hasta (vto)">            
              <b-form-input type="date" size="sm" v-model="filters.date_end" placeholder="Fecha Hasta"></b-form-input>
            </b-form-group>
          </b-col>          
          <b-col sm="2">
            <b-form-group label="Estado">
              <v-select :options="arr.filters.available" v-model="filters.available" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </b-form-group>
          </b-col>
          <b-col sm="4" class="mt-4">
            <b-button variant="outline-dark" size="sm" @click="load()" class="pull-left">
              <b-icon icon="filter" size="sm" class="mr-1" style="font-size:15px;"></b-icon>              
              Filtrar
            </b-button>
          </b-col>            
        </b-row>
      </b-card>
      
      <b-row class="p-0" align-h="end">                
        <b-col md="6">
          <b-button-group class="pull-right">            
            <b-button variant="info" @click="add()">
              <b-icon icon="plus"></b-icon> Agregar Cheque
            </b-button>
          </b-button-group>            
        </b-col>
      </b-row>
      
      <b-card header-tag="header" footer-tag="footer" class="cheques-detail-movimientos p-0 m-0">
        <b-row>
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="true"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">                       
                  
                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"                    
                    :key="field.key"
                    :style="{ width: field.width }"
                  >
                </template> 

                <template v-slot:cell(origen)="data">
                  <div v-if="data.item.origen" :id="'origen-extra-'+data.item.id" style="cursor: pointer;">                    
                    {{ data.item.origen.customer }}
                  </div>
                  <b-popover v-if="data.item.origen" :target="'origen-extra-'+data.item.id" triggers="hover" placement="top">
                    <template #title>Datos de Origen</template>

                    <span v-if="data.item.origen.point_sale">
                      {{data.item.origen.types_vouchers}} <br>
                      {{data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0')}} 
                      <hr>
                      {{moment(data.item.origen.date).format('DD MMMM YYYY')}} <br>
                      ({{data.item.origen.customer_id}}) - {{data.item.origen.customer}} 
                      <hr>
                      {{ data.item.origen.observations }}                      
                    </span>
                  </b-popover>                  
                </template>

                <template v-slot:cell(date)="data">
                  <div v-if="data.item.date">
                    {{ moment(data.item.date).format('DD MMMM YYYY') }}
                  </div>
                </template>

                <template v-slot:cell(days)="data">
                  <div v-if="data.item.date && data.item.date_expiration">
                    {{ moment(data.item.date_expiration).diff(moment(), 'days') }}
                  </div>
                </template>

                <template v-slot:cell(date_expiration)="data">
                  <div v-if="data.item.date_expiration">
                    <b>{{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}</b>
                  </div>
                </template>

                <template v-slot:cell(amount)="data">
                  <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.amount)}}</b>
                </template>

                <template v-slot:cell(transmitter)="data">
                  <span v-if="data.item.transmitter_name">
                    <b>Nombre:</b> {{data.item.transmitter_name}}
                  </span>
                  <span v-if="data.item.transmitter_documents_number">
                    | <b>CUIT</b> {{data.item.transmitter_documents_number}}
                  </span>
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations" v-b-tooltip.hover :title="data.item.observations">
                    <b-icon icon="chat-square-text"></b-icon>
                  </div>                                      
                </template>

                <template v-slot:cell(nd)="data">
                  <b-badge v-if="data.item.nd">SI</b-badge>            
                </template>   


                <template v-slot:cell(destino)="data">                                    
                  <div v-if="data.item.destino" :id="'destino-extra-'+data.item.id" style="cursor: pointer;">                    
                    {{ data.item.destino.supplier }}
                  </div>
                  <b-popover v-if="data.item.destino" :target="'destino-extra-'+data.item.id" triggers="hover" placement="top">
                    <template #title>Datos de Destino</template>                    

                    <span v-if="data.item.destino.point_sale">
                      {{data.item.destino.types_vouchers}} <br>
                      {{data.item.destino.point_sale.toString().padStart(4,'0') + '-' + data.item.destino.number.toString().padStart(8,'0')}} 
                      <hr>
                      {{moment(data.item.destino.date).format('DD MMMM YYYY')}} <br>
                      ({{data.item.destino.supplier_id}}) - {{data.item.destino.supplier}} 
                      <hr>
                      {{ data.item.destino.observations }}
                    </span>
                  </b-popover>                  
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="" size="sm" variant="outline-dark" class="pull-right">
                    <b-dropdown-item @click="edit(data.item)">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-row align-h="end" v-if="table.items.length" class="mt-2">
        <b-col sm="4">      
          <b-card header-tag="header" footer-tag="footer" class="p-0 cheques-detail-totales">
            <b-table-simple hover small responsive bordered class="m-0 p-0">             
              <b-thead head-variant="dark">                                          
                <b-tr>                      
                  <b-th width="50%" class="text-right">
                    <div class="mr-1">Total</div>
                  </b-th>                                
                  <b-th width="50%" class="text-right">
                    <div class="mr-1">Resumen</div>                        
                  </b-th>                                    
                </b-tr>
              </b-thead>  
              <b-tbody> 
                <b-tr>                                            
                  <b-td class="text-right align-middle cash-cheque-amount-totals">   
                    <div class="mr-1" v-if="true" :class="{'cash-cheque-text-danger':this.amountTotal<0, 'cash-cheque-text-success': this.amountTotal>0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(  this.amountTotal )}}
                    </div>            
                  </b-td>
                  <b-td class="text-right align-middle">        
                    <div class="mr-1 cash-cheque-amount-totals" :class="{'cash-cheque-text-danger':this.getAmountResumen()<0, 'cash-cheque-text-success':this.getAmountResumen()>0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format( this.getAmountResumen() )}}
                    </div>            
                  </b-td>                                    
                </b-tr>
              </b-tbody>
            </b-table-simple>            
          </b-card>
        </b-col>
      </b-row>

      <b-card header-tag="header" footer-tag="footer" class="mt-2">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.form.title}}
        </div>

        <b-row>           
          <b-col md="6">
            <b-form-group label="Número">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.number"
                            required
                            placeholder="Ingresar el número">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Importe">
              <b-input-group prepend="$" size="sm">            
                <b-form-input v-model="crud.form.amount" 
                              type="number" 
                              setp="0.01" 
                              min="0.00"
                              :readonly="crud.form.id>0">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Fecha">
              <b-form-datepicker size="sm"  
                                 v-model="crud.form.date" 
                                 placeholder="Fecha" 
                                 local="es">
              </b-form-datepicker>                      
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Vencimiento">
              <b-form-datepicker size="sm" 
                                 v-model="crud.form.date_expiration" 
                                 placeholder="Fecha Vencimiento" 
                                 local="es">
              </b-form-datepicker>                      
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Banco">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.bank"
                            required
                            placeholder="Ingresar el banco">
              </b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="6">
            <b-form-group label="Nombre Emisor">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.transmitter_name"
                            required
                            placeholder="Ingresar el nombre del emisor">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="CUIT Emisor">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.transmitter_documents_number"
                            required
                            placeholder="Ingresar el CUIT del emisor">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Observaciones">
              <b-form-textarea                
                v-model="crud.form.observations"
                placeholder="Ingresar las observaciones..."
                rows="3"
                max-rows="6"></b-form-textarea>
            </b-form-group>
          </b-col>  

          <b-col md="12" class="mb-3">       
            <b-form-group label="Tipo de Cheque" description="Si la opción se activa, los movimientos realizados, solo pueden utilizarse desde un punto de venta no declarado.">         
              <b-form-checkbox v-model="crud.form.nd" 
                                switch 
                                size="sm">
                ND
              </b-form-checkbox>                      
            </b-form-group>      
          </b-col>           
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'

  export default {
    data: () => {
      return {      
        access: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'cheques',
          elements: {}
        },  
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', class: "align-middle text-center font-weight-bold", width:"3%"},            
            {key: 'origen', label: 'Origen', class: "align-middle", width:"8%"},            
            {key: 'bank', label: 'Banco', class: "align-middle", width:"8%"},
            {key: 'number', label: 'Número', class: "align-middle text-center", width:"8%"},
            {key: 'date', label: 'Fecha', class: "align-middle text-center", width:"8%"},
            {key: 'date_expiration', label: 'Vencimiento', class: "align-middle text-center", width:"10%"},                                    
            {key: 'days', label: 'Días', class: "align-middle text-center", width:"5%"},            
            {key: 'transmitter', label: 'Emisor', class: "align-middle text-left", width:"20%"},
            {key: 'amount', label: 'Importe', class: "align-middle text-right", width:"10%"},
            {key: 'observations', label: '', class: "align-middle text-center", width:"5%"},                        
            {key: 'nd', label: 'ND', class:"align-middle", width:"5%"},
            {key: 'destino', label: 'Destino', class: "align-middle", width:"8%"},            
            {key: 'f_action', label:'', class: "align-middle", width:"2%"},
          ],
          filter: null,
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 50,
        },      
        crud: {
          form: {
            id: 0,
            number: 0,
            date: '',
            date_expiration: '',
            amount: 0,
            bank: '',
            transmitter_name: '',
            transmitter_documents_number: '',
            observations: '',
            nd: false,
          },                 
        },
        modal: {
          form: {
            active: false,
            title: ''
          },        
        },
        arr: {
          filters : {
            available: [
              {code: true, label: 'En cartera'},
              {code: false, label: 'Entregado'}
            ]
          },                       
        },        
        filters: {
          date_start: '',
          date_end: '',
          available: null,
        },
        amountTotal: 0,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.getAmountTotal()

      this.filterLoad()
      this.restoreFilterStorage() 

      this.load()

      this._start = true
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.getAmountTotal()
      this.filterLoad()
      this.load()        
    },         
    computed: {
      getCurrencyCode() {
        return 'ARS'
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      filterLoad() { 
        this.filters.date_start = moment().format('YYYY-MM-DD') 
        this.filters.date_end = moment().add(30, 'days').format('YYYY-MM-DD') 
      },
      load() {
        this.saveFilterStorage()    
        
        let loader = this.$loading.show()  
        
        var result = serviceAPI.filtrarCheques(this.filters, this.table.currentPage)        

        result.then((response) => {
          loader.hide()          
          this.table.items = response.data.data
          this.table.items.forEach(element => {            
            if(element.date_expiration <= moment().subtract(25, 'days').format('YYYY-MM-DD') && element.available) {
              element._rowVariant = 'danger'  
            }            
            if(element.date_expiration > moment().subtract(25, 'days').format('YYYY-MM-DD') && element.date_expiration <= moment().add(15, 'days').format('YYYY-MM-DD') && element.available) {
              element._rowVariant = 'warning'  
            }
            if(element.date_expiration > moment().add(15, 'days').format('YYYY-MM-DD') && element.available) {
              element._rowVariant = 'success'  
            }

            if(!element.available) {
              element._rowVariant = 'secondary'  
            }            
          });
        })
        .catch(error => {                         
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });     
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.number = 0
        this.crud.form.date = ''
        this.crud.form.date_expiration = ''
        this.crud.form.amount = 0
        this.crud.form.bank = ''
        this.crud.form.transmitter_name = ''
        this.crud.form.transmitter_documents_number = ''
        this.crud.form.observations = ''
        this.crud.form.nd = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Cheque"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.number = item.number
        this.crud.form.date = item.date
        this.crud.form.date_expiration = item.date_expiration
        this.crud.form.amount = item.amount
        this.crud.form.bank = item.bank
        this.crud.form.transmitter_name = item.transmitter_name
        this.crud.form.transmitter_documents_number = item.transmitter_documents_number
        this.crud.form.observations = item.observations
        this.crud.form.nd = item.nd
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Cheque"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.number = item.number 

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.number + '?', {
          title: 'Borrar Cheque',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCheque(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarCheque(this.crud.form);
        } else {
          var result = serviceAPI.agregarCheque(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()

          this.getAmountTotal()
          
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },     

      getAmountTotal() {        
        let result = serviceAPI.sumarChequesDisponibles();
        result.then((response) => {          
          this.amountTotal = parseFloat(response.data)
        })
      },
      getAmountResumen() {
        let total = 0
        this.table.items.forEach(element => {
          total = total + parseFloat(element.amount)
        });
        
        return total
      },  

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_cash_cheques', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_cash_cheques')) {
          this.filters = JSON.parse(Storage.getValue('filter_cash_cheques'))
        }         
      },             
    }    
  }
</script>
<style scoped>
  .cash-cheque-amount-totals {
    font-size: 15px;
    color:darkgreen;
    font-weight: 800;
  }
  .cash-cheque-text-success {
    color:green;    
  }
  .cash-cheque-text-danger {
    color:red;
  }
  
  .cheques-detail-totales .card-body {
    padding: 0;
  }
  .cheques-detail-movimientos .card-body {
    padding: 0;
  }  
</style>